import { Button, Form, Input, Modal, Row, Space } from 'antd';

import { CloseIconsForModalWithDataTestId } from '@app/components';
import { ERROR_REQUIRED_FIELD } from '@app/constants';
import { generateSpanWithDataTestId } from '@app/shared/utils';

import type {
  CreateTemplateFormInterface,
  TemplateCreationDialogType,
} from '@pages/Users/AccessRightsTab/types';

const { useForm } = Form;
const { TextArea } = Input;

export const TemplateCreationDialog: TemplateCreationDialogType = ({
  isOpened,
  isLoading,
  onCancel,
  onFinish,
}) => {
  const [form] = useForm<CreateTemplateFormInterface>();

  return (
    <Modal
      title={generateSpanWithDataTestId(
        'Создание шаблона прав',
        'create-rights-template-title'
      )}
      data-testid="create-rights-template-popup"
      open={isOpened}
      okButtonProps={{
        className: 'display-none',
      }}
      cancelButtonProps={{
        className: 'display-none',
      }}
      onCancel={onCancel}
      afterClose={form.resetFields}
      closeIcon={<CloseIconsForModalWithDataTestId />}
    >
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        onFinish={onFinish}
      >
        <Form.Item
          label={generateSpanWithDataTestId(
            'Название шаблона',
            'template-name-title'
          )}
          name="Name"
          rules={[{ required: true, message: ERROR_REQUIRED_FIELD }]}
        >
          <Input
            placeholder="Исполнитель"
            data-testid="template-name-input"
            maxLength={60}
            count={{
              show: true,
              max: 60,
            }}
          />
        </Form.Item>

        <Form.Item
          label={generateSpanWithDataTestId(
            'Описание шаблона',
            'template-description-title'
          )}
          name="Description"
        >
          <TextArea
            data-testid="template-description-input"
            placeholder="Оказывает услуги"
            rows={4}
            maxLength={400}
            count={{
              show: true,
              max: 400,
            }}
          />
        </Form.Item>

        <Row gutter={16} justify="end">
          <Space>
            <Button
              loading={isLoading}
              disabled={isLoading}
              onClick={onCancel}
              data-testid="cancel"
            >
              Отменить
            </Button>
            <Button
              loading={isLoading}
              disabled={isLoading}
              type="primary"
              htmlType="submit"
              data-testid="create-template"
            >
              Создать шаблон
            </Button>
          </Space>
        </Row>
      </Form>
    </Modal>
  );
};
